import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'indianFormat',
    standalone: false
})
export class IndianFormatPipe implements PipeTransform {
    transform (value: string | number): string {
        if (value) {
            return (+value).toLocaleString('en-IN');
        }
        return '0';
    }
}
